/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import easeScaleInGif from '../../../assets/images/transitions/easeScaleIn.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_SCALE_IN = 'easeScaleIn';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeScaleInPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_SCALE_IN,

  // A human friendly name for the preset.
  humanName: 'Ease Scale - In',

  // A preview of the transition.
  gif: easeScaleInGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'transform.scale': {
      time: {
        end: 'start.1000',
        start: 'start.0'
      },
      easing: EASINGS.easeOutExpo,
      values: [
        0,
        1
      ],
      immediateRender: true
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_SCALE_IN,
    options: {},
  },
};

easeScaleInPresetDetails.template.options = lodash.cloneDeep(easeScaleInPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_SCALE_IN;

// This defines the value of the presets object.
export default easeScaleInPresetDetails;
